export * from './profile-edit-page.component';
